module.exports = __webpack_public_path__ + "static/img/satisfy.da78b41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/satisfy.png
// module id = pb2X
// module chunks = 29